import {
    EvidenceHistory,
    EvidenceHistoryGap,
    EvidenceHistoryResponse,
} from "../../api/models/Evidence";
import EvidenceHistoryTimelineItem from "./EvidenceHistoryTimelineItem";
import { v4 as generateUuid } from "uuid";

export const isEvidenceHistoryGap = (
    item: unknown
): item is EvidenceHistoryGap => {
    return (item as EvidenceHistory).documentUrl === undefined;
};

export type EvidenceHistoryTimelineProps = {
    data: EvidenceHistoryResponse;
};

type TimelineItem = (EvidenceHistory | EvidenceHistoryGap) & { uuid: string };

const EvidenceHistoryTimeline = ({ data }: EvidenceHistoryTimelineProps) => {
    const evidenceHistoryData: TimelineItem[] = [...data.evidence, ...data.gaps]
        .sort((a, b) => {
            const aFromDate = isEvidenceHistoryGap(a)
                ? a.fromDate
                : a.validFromDate;
            const bFromDate = isEvidenceHistoryGap(b)
                ? b.fromDate
                : b.validFromDate;
            return (
                new Date(aFromDate).getTime() - new Date(bFromDate).getTime()
            );
        })
        .map((item) => ({
            ...item,
            uuid: generateUuid(),
        }));

    if (evidenceHistoryData.length === 0)
        return (
            <div className="flex-1 flex justify-center items-center">
                <div className="flex flex-col items-center">
                    <p className="mt-2 opacity-60">No evidence history found</p>
                </div>
            </div>
        );

    return (
        <>
            {evidenceHistoryData.map((evidenceHistoryDataItem, index) => (
                <EvidenceHistoryTimelineItem
                    {...evidenceHistoryDataItem}
                    key={evidenceHistoryDataItem.uuid}
                    isFirstItem={index === 0}
                    isLastItem={index === evidenceHistoryData.length - 1}
                    previousItemIsMissing={
                        evidenceHistoryData[index - 1] &&
                        isEvidenceHistoryGap(evidenceHistoryData[index - 1])
                    }
                    nextItemIsMissing={
                        evidenceHistoryData[index + 1] &&
                        isEvidenceHistoryGap(evidenceHistoryData[index + 1])
                    }
                />
            ))}
        </>
    );
};

export default EvidenceHistoryTimeline;
